import { useRef, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { ModalCloseButton } from '@quality-vet/ui/modal-close-button';

import { useDialogFocusTrap } from './use-dialog-focus-trap';

export function Modal({
  children,
  fullScreen = false,
  active = true,
  label,
  onClose,
  closeDisabled = false,
}: {
  active?: boolean;
  children: ReactNode;
  closeDisabled?: boolean;
  fullScreen?: boolean;
  label: string;
  onClose: () => void;
}) {
  const dialogRef = useRef<HTMLElement>(null);
  useDialogFocusTrap(dialogRef, closeDisabled ? () => undefined : onClose, active);

  return createPortal(
    <div
      hidden={!active}
      className={`app-modal-backdrop${fullScreen ? ' app-modal-backdrop-fullscreen' : ''}`}
      data-modal-layer
      role="presentation"
      onClick={(event) => {
        if (event.target === event.currentTarget && !closeDisabled) onClose();
      }}
    >
      <section
        aria-label={label}
        aria-modal="true"
        className={`app-modal${fullScreen ? ' app-modal-fullscreen' : ''}`}
        ref={dialogRef}
        role="dialog"
        tabIndex={-1}
      >
        <ModalCloseButton
          className="app-modal-close"
          disabled={closeDisabled}
          label={closeDisabled ? `${label} acknowledgement required` : `Close ${label}`}
          onClick={onClose}
        />
        {children}
      </section>
    </div>,
    document.body,
  );
}
